const getConvertedDate = (date: string) => {
  let newDate = new Date(date),
    mnth = ("0" + (newDate.getMonth() + 1)).slice(-2),
    day = ("0" + newDate.getDate()).slice(-2);
  return [newDate.getFullYear(), mnth, day].join("-");
};

export default getConvertedDate;
